<template>
  <el-dialog
    :title="rowData.sysGroupPermisson ? '编辑' : '添加'"
    :visible.sync="dialogVisible"
    width="40%"
    class="addChannelAccountDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addChannelAccountFrom" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="渠道账号" prop="groupId">
            <el-input v-model="formData.groupId" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="渠道名称" prop="groupName">
            <el-input v-model="formData.groupName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="银行账户名" prop="partnerName">
            <el-input v-model="formData.partnerName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="银行账号" prop="bankAcount">
            <el-input v-model="formData.bankAcount" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="税号" prop="taxPayerCode">
            <el-input v-model="formData.taxPayerCode" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item class="is-required" label="框架协议">
            <el-upload
              class="upload"
              :action="baseUrl"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :limit="1"
              :file-list="fileList"
              accept=".pdf,.PDF"
            >
              <div>
                <el-button type="primary"><i class="iconfont icon-shangchuan-icon1" />点击上传</el-button>
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { newApplicationFormApi } from '@/views/newApplicationForm/service';

export default {
  data () {
    return {
      rules: {
        groupId: [
          { required: true, message: '请输入渠道账号', trigger: 'blur' }
        ],
        groupName: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' }
        ],
        partnerName: [
          { required: true, message: '请输入银行账户名', trigger: 'blur' }
        ],
        bankAcount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        taxPayerCode: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {
      },
      baseUrl: window._env_.VUE_APP_FILESERVICE_URL,
      fileList: []
    };
  },
  props: {
    channelAccountDialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    channelAccountDialogVisible (val) {
      if (val) {
        if (this.rowData.sysGroupPermisson) {
          this.formData = {
            groupPermissonId: this.rowData.sysGroupPermisson.id,
            qdBillingId: this.rowData.id,
            groupId: this.rowData.sysGroupPermisson.groupId,
            groupName: this.rowData.sysGroupPermisson.groupName,
            partnerName: this.rowData.qdBilling.partnerName,
            bankAcount: this.rowData.qdBilling.bankAcount,
            taxPayerCode: this.rowData.qdBilling.taxPayerCode
          };
        }
      } else {
        this.formData = {};
        this.fileList = [];
        this.$nextTick(() => {
          this.$refs.addChannelAccountFrom.clearValidate();
        });
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    handleSuccess (response, file, fileList) {
      if (response.status === '200') {
        this.fileList = fileList;
      } else {
        this.fileList.splice(this.fileList.length - 1);
        this.$message.error(response.err);
      }
      this.baseUrl = this.baseUrl.split('?Token')[0];
    },
    beforeUpload (file) {
      return new Promise((resolve, reject) => {
        let fileSize = file.size / 1024 / 1024 < 10;
        const isPdf = file.type === 'application/pdf';
        if (!isPdf) {
          this.$message.error('上传协议只能是 JPG 格式!');
          reject(new Error('上传协议只能是 JPG 格式!'));
          return false;
        }
        if (!fileSize) {
          this.$message.error('上传的文件大小不能超过10M');
          reject(new Error('上传的文件大小不能超过10M'));
          return false;
        }
        newApplicationFormApi.getFileToken().then(res => {
          if (res.status === '200') {
            if (this.baseUrl.indexOf('?Token=') < 0) {
              this.baseUrl = this.baseUrl + '?Token=' + res.data;
            }
            resolve();
          } else {
            reject(res.status);
          }
        });
      });
    },
    beforeRemove (file, fileList) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    },
    submitHandlen () {
      this.$refs['addChannelAccountFrom'].validate((valid) => {
        if (valid) {
          if (this.fileList.length < 1) {
            this.$message.error('请上传框架协议');
            return;
          }
          let fileData = this.fileList[0].response.data[0];
          if (!fileData.FID) {
            this.$message.error('协议上传失败，请删除重新上传');
            return;
          }
          this.formData.fileId = fileData.FID;
          this.formData.fileName = fileData.FullName;
          if (this.formData.groupPermissonId) {
            this.$emit('editAccountSubHandle', this.formData);
          } else {
            this.$emit('addAccountSubHandle', this.formData);
          }
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
